import { FC } from "react";

import { useAEMContent } from "hooks/useAEMContent/useAEMContent";

import {
  hasContentToDisplay,
  hasDismissedAlert,
} from "./alertBannerWrapper.helpers";
import { AlertBanner } from "./components/AlertBanner/AlertBanner";
import { AlertBannerResponse } from "./components/AlertBanner/alertBanner.types";

export const AlertBannerWrapper: FC = () => {
  const alertBannerResponse = useAEMContent<AlertBannerResponse | undefined>({
    contentUrl: "/asset/content/cv-api/enus_alert-banner.headless.json",
    fallbackContent: undefined,
    logError: false,
  });

  const bannerContent = Array.isArray(alertBannerResponse)
    ? alertBannerResponse[0]
    : alertBannerResponse;
  if (
    !hasContentToDisplay(bannerContent) ||
    hasDismissedAlert(bannerContent.id)
  ) {
    return null;
  }

  return <AlertBanner content={bannerContent} />;
};
